import type {
  AuthorizationContext,
  AuthorizationRepository,
} from "@/data/repositories/authorizationRepository";

export class DummyAuthorizationRepository implements AuthorizationRepository {
  async getContext(_organizationId: string, eventId?: string): Promise<AuthorizationContext> {
    return {
      organizationRoles: ["organization_owner"],
      eventRoles: eventId ? ["event_owner"] : [],
    };
  }
}

